<template>
	<div
		v-tooltip.bottom="{
			html: true,
			delay: { show: 500, hide: 900 },
			content: '<a target=\'_blank\' href=\'https://docs.google.com/forms/u/2/d/e/1FAIpQLSdJetbo7AQDcEAiTmLDlRBelNGyFpFtiexEpLBqWxBNjcaPnw/viewform\'>BETA</a>'
		}"
		class="flex"
	>
		<div
			:class="[
				'won-tag-light-gray size-6 rounded-l-md border-r border-won-gray-light',
				'flex cursor-pointer items-center justify-center select-none',
			]"
			@click="() => emit('move-up')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				:class="['size-4 stroke-2', {'won-color-disabled': currentPage==1}]"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
				/>
			</svg>
		</div>
  
		<div
			:class="[
				'flex h-6 w-[46px] cursor-pointer items-center',
				'won-tag-light-gray justify-center select-none',
			]"
		>
			<div class="won-color-gray text-sm leading-6">{{ currentPage }}/{{ nrOfPages }}</div>
		</div>
  
		<div
			:class="[
				'won-tag-light-gray size-6 rounded-r-md border-l border-won-gray-light',
				'flex cursor-pointer items-center justify-center select-none',
			]"
			@click="() => emit('move-down')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				:class="['size-4 stroke-2', {'won-color-disabled': currentPage==nrOfPages}]"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
				/>
			</svg>
		</div>
	</div>
</template>
  
<script setup>
defineProps({
	nrOfPages: {
		type: Number,
		default: 1,
	},
	currentPage: {
		type: Number,
		default: 1,
	}
});

const emit = defineEmits(['move-up', 'move-down']);
</script>